import { getCurrentPrepaidBalanceQuery } from "./queries";

export const getCurrentPrepaidBalance = () =>
    getCurrentPrepaidBalanceQuery().then(responseObject => {
        if (!responseObject.prepaid_balance) return 0;

        const prepaidBalanceInCents = responseObject.prepaid_balance.balance;
        const prepaidBalanceInDollars = Number(prepaidBalanceInCents) / 100;

        return prepaidBalanceInDollars;
    });
